import React from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import SalesTransactions from './Receivable';

export default function ReceivablePage() {
  const { authorizedUser } = useSelector(
    ({ auth }) => ({
      authorizedUser: auth.user,
    }),
    shallowEqual
  );
  return (
    <div>
      <SalesTransactions authorizedUser={authorizedUser} />
    </div>
  );
}
